import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-thermometer",
  "use": "icon-si-glyph-thermometer-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-thermometer\" id=\"icon-si-glyph-thermometer\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>870</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M9.984,9.261 L9.984,0.735 C9.984,0.364 9.613,0.063 9.154,0.063 L7.844,0.063 C7.386,0.063 7.015,0.364 7.015,0.735 L7.015,9.26 C5.742,9.779 4.999,11.026 4.999,12.485 C4.999,14.409 6.56,15.969 8.483,15.969 C10.406,15.969 11.967,14.408 11.967,12.485 C11.969,11.026 11.256,9.78 9.984,9.261 L9.984,9.261 Z M7.947,0.957 L9.02,0.957 L9.02,10 L7.947,10 L7.947,0.957 L7.947,0.957 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-thermometer.svg
// module id = ZKeI
// module chunks = 62